import { Component, inject, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService } from '../../services/translation.service';

@Component({
  selector: 'app-events',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './events.html',
  styleUrl: './events.scss',
})
export class Events {
  ts = inject(TranslationService);
  t = this.ts.t;

  events = computed(() => [
    { title: this.t().ev_card1_title, desc: this.t().ev_card1_desc },
    { title: this.t().ev_card2_title, desc: this.t().ev_card2_desc },
    { title: this.t().ev_card3_title, desc: this.t().ev_card3_desc },
    { title: this.t().ev_card4_title, desc: this.t().ev_card4_desc },
    { title: this.t().ev_card5_title, desc: this.t().ev_card5_desc },
  ]);
}